<script lang="ts" setup>
import { useI18n } from "vue-i18n";
import OmniTooltip from "@/components/omni/OmniTooltip.vue";
import { computed } from "vue";
import { useBaseView } from "@/composables";
import { DispatcherPermissionValue } from "@/api/dto/dispatcher.dto";
import type { RouteLocationRaw } from "vue-router";
import LinkButton from "@/components/buttons/LinkButton.vue";

const { t } = useI18n();
const { hasAccess } = useBaseView();

defineProps<{
  id: number;
  to: RouteLocationRaw;
}>();

const hasAccessToEdit = computed(() => {
  return hasAccess(DispatcherPermissionValue.EditOrCreateUser);
});
</script>

<template>
  <omni-tooltip :disabled="hasAccessToEdit">
    <template #activator>
      <link-button :to="to" variant="text">
        <v-icon :disabled="!hasAccessToEdit" small>mdi-pencil</v-icon>
      </link-button>
    </template>

    {{ t("permission.edit-company") }}
  </omni-tooltip>
</template>
